import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Template } from '../models/api.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService {
  constructor(private readonly api: ApiService) {}

  list(): Observable<Template[]> {
    return this.api.get<Template[]>('/templates');
  }

  create(payload: Template): Observable<Template> {
    return this.api.post<Template>('/templates', payload);
  }
}
